import React from "react";

/** Twelve gold stars arranged in a circle, the EU motif. */
export function EuStars({ size = 96, color = "#C9A84C", className = "" }) {
    const stars = [];
    const radius = size / 2 - size * 0.12;
    const center = size / 2;
    for (let i = 0; i < 12; i++) {
        const angle = (i / 12) * Math.PI * 2 - Math.PI / 2;
        const cx = center + radius * Math.cos(angle);
        const cy = center + radius * Math.sin(angle);
        stars.push(<Star key={i} cx={cx} cy={cy} r={size * 0.055} color={color} />);
    }
    return (
        <svg
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            className={className}
            aria-hidden="true"
        >
            {stars}
        </svg>
    );
}

function Star({ cx, cy, r, color }) {
    const points = [];
    for (let i = 0; i < 10; i++) {
        const ang = (i / 10) * Math.PI * 2 - Math.PI / 2;
        const rr = i % 2 === 0 ? r : r / 2.4;
        points.push(`${cx + rr * Math.cos(ang)},${cy + rr * Math.sin(ang)}`);
    }
    return <polygon points={points.join(" ")} fill={color} />;
}

export default EuStars;
